const CollapseProducts = () => {
  const collapseBtn = document.querySelector('.collapse-btn')
  const collapseTop = document.querySelector('.collapse-top')
  const collapseBottom = document.querySelector('.collapse-bottom')

  if (!collapseBtn) return

  collapseBtn.addEventListener('click', e => {
    e.preventDefault()

    $(collapseBottom).slideToggle('fast')

    collapseTop.classList.toggle('--active')
  })
}
export default CollapseProducts
